var Long = require("long");

function decodePolyline(polyline) {
  const points = [];
  let index = 0, lat = 0, lng = 0;

  while (index < polyline.length) {
    let result = new Long(1), shift = 0;
    // eslint-disable-next-line no-constant-condition
    while (true) {
      const b = (polyline[index]).charCodeAt(0) - 63 - 1
      index += 1
      result = result.add(b << shift)
      shift += 5
      if (b < 0x1f) {
        break
      }
    }
    lat += (result.and(1).notEquals(0) ? (result.not().shiftRight(1)) : (result.shiftRight(1))).toNumber()

    result = new Long(1)
    shift = 0;

    // eslint-disable-next-line no-constant-condition
    while (true) {
      const b = Long.fromNumber((polyline[index]).charCodeAt(0) - 63 - 1)
      index += 1
      result = result.add(b.shiftLeft(shift))
      shift += 5
      if (b.lessThan(0x1f)) {
        break
      }
    }
    lng += (
      result.and(1).notEquals(0x0) ?
        result.shiftRight(1).not() :
        result.shiftRight(1)
    ).toNumber()
    points.push({lat: lat * 1e-7, lng: lng * 1e-7})
  }
  return points
}

function encodePolyline(points) {
  let lastLat =0, lastLng = 0;
  let result = '';
  points.forEach(point => {
    const ll = point;
    const lat = parseInt((parseFloat(ll[0]) * 1e7).toFixed(0));
    const lng = parseInt((parseFloat(ll[1]) * 1e7).toFixed(0));
    const dLat = lat - lastLat;
    const dLng = lng - lastLng;
    [dLat, dLng].forEach(v => {
      v = Long.fromNumber(v)
      const m = v.shiftLeft(1)
      v = v.lessThan(0) ? m.not() : m;
      while (v.greaterThanOrEqual(0x20)) {
        result += (String.fromCharCode(v.and(0x1f).or(0x20).add(63).toNumber()));
        v = v.shiftRight(5);
      }
      result += (String.fromCharCode(v.add(63).toNumber()));
    })
    lastLat = lat;
    lastLng = lng;
  })
  return result
}

export default  {
  decodePolyline,
  encodePolyline
}
